module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-UltraLight.fbd0822f.woff";